import { Form, Formik } from 'formik';
import { Props, Values } from './CodeBookItems.types';
import * as Yup from 'yup';
import FormField from '../../components/field/FormField';
import Button from '../../components/button/Button';
import { useTranslation } from '../../context/translationContext';
import { useCurrentCompany } from '../../hooks/useCompany';
import { Loader } from '../../components/loader/Loader';
import { useNavigate } from 'react-router-dom';
import { paths } from '../../pages/RouterContainer';

/**
 *  Form component for creating / editing code book items
 */
export const CodeBookItemsForm = ({ onSubmit, initialValues }: Props) => {
  const { t } = useTranslation();
  const { company } = useCurrentCompany();
  const navigate = useNavigate();

  const _initialValues: Values = {
    name: '',
    code: '',
  };

  // only name is required
  const CodeBookItemSchema = Yup.object().shape({
    name: Yup.string().required('Code book item name is required.'),
  });

  if (!company) return <Loader />;
  return (
    <Formik
      enableReinitialize
      initialValues={initialValues || _initialValues}
      onSubmit={onSubmit}
      validationSchema={CodeBookItemSchema}
    >
      {({ errors, touched }) => (
        <Form className="w-full text-center">
          <div className="my-4">
            <FormField
              id="name"
              name="name"
              label={t('page.code-book-item.input-name')}
              errors={errors}
              touched={touched}
            />
          </div>
          {company.codeBookItemsUseCode && (
            <div className="my-4">
              <FormField
                id="code"
                name="code"
                label={t('page.code-book-item.input-code')}
                errors={errors}
                touched={touched}
              />
            </div>
          )}
          <div className="flex float-left">
            <Button
              title={t('general.back')}
              color="gray"
              className="mr-3"
              onClick={() => navigate(`/${paths.CODE_BOOK_ITEMS}`)}
            />
            <Button title={t('general.save')} color="green" type="submit" showLoading />
          </div>
        </Form>
      )}
    </Formik>
  );
};
